export default __webpack_public_path__ + "static/undraw_recording_lywr-29f47f96b2d02a36bcb82f32180027ee.svg";